import { useState, useEffect, useCallback } from 'react';

/**
 * useAuth - 토큰 관리 hook
 *
 * - localStorage에 토큰 저장
 * - 토큰 변경 시 자동으로 상태 업데이트
 * - login/logout/checkAuth 제공
 */
const TOKEN_KEY = 'pstock_token';
const USER_KEY  = 'pstock_user';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setAuth(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event('auth-changed'));
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.dispatchEvent(new Event('auth-changed'));
}

export default function useAuth() {
  const [token, setToken] = useState(getToken());
  const [user, setUser]   = useState(getUser());

  useEffect(() => {
    const handler = () => {
      setToken(getToken());
      setUser(getUser());
    };
    window.addEventListener('auth-changed', handler);
    return () => window.removeEventListener('auth-changed', handler);
  }, []);

  const login = useCallback((newToken, newUser) => {
    setAuth(newToken, newUser);
  }, []);

  const logout = useCallback(() => {
    clearAuth();
  }, []);

  return {
    token,
    user,
    isAuthenticated: !!token,
    login,
    logout,
  };
}
